import ApiService from "../api.service";
const TradeTypeRestrictionService ={
    GetAll(lang){
        return ApiService.get(`/TradeTypeRestriction/GetAll?lang=${lang}`)
    },
    GetList(Search,SortColumn,OrderType,PageNumber,PageLimit){
        return ApiService.get(`/TradeTypeRestriction/GetList?Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}`)
    },
    GetImageForDashboard(){
        return ApiService.get(`/TradeTypeRestriction/GetImageForDashboard`)
    },
    Get(id){
        return ApiService.get(`/TradeTypeRestriction/Get?id=${id}`)
    },
    Update(data){
        return ApiService.post(`/TradeTypeRestriction/Update`,data)
    },
    Delete(id){
        return ApiService.delete(`/TradeTypeRestriction/Delete?id=${id}`)
    }
}
export default TradeTypeRestrictionService